// Укрзализныця бракует вагон при неравномерной нагрузке на тележки:
// |тележка1 − тележка2| / брутто > порога.
export const BOGIE_IMBALANCE_THRESHOLD = 0.05;

export function bogieSkewRatio(bogie1_t, bogie2_t, brutto) {
  const b = Number(brutto) || 0;
  if (b <= 0) return 0;
  return Math.abs(Number(bogie1_t) - Number(bogie2_t)) / b;
}

export function hasBogieImbalance(w) {
  if (!w) return false;
  return bogieSkewRatio(w.bogie1_t, w.bogie2_t, w.weight_brutto) > BOGIE_IMBALANCE_THRESHOLD;
}

/**
 * Синтетическое показание весов: брутто делится примерно пополам.
 * @param {number} brutto
 * @param {{ empty?: boolean, forceSevere?: boolean, rnd?: () => number }} opts
 *   empty — порожний: почти ровно (тара);
 *   forceSevere — принудительный перекос > порога (для тестов/демо);
 *   rnd — источник случайности (по умолчанию Math.random).
 */
export function synthesizeBogies(brutto, opts = {}) {
  const rnd = opts.rnd || Math.random;
  const b = +Number(brutto).toFixed(1) || 0;
  const half = b / 2;

  if (opts.empty) {
    const skew = (rnd() * 2 - 1) * 0.35;
    const bogie1_t = +(half + skew).toFixed(1);
    return { bogie1_t, bogie2_t: +(b - bogie1_t).toFixed(1) };
  }

  // ~12% гружёных — заметный перекос (>5% брутто) для демо проблемы УЗ
  const severe = opts.forceSevere === true || (opts.forceSevere !== false && rnd() < 0.12);
  let delta;
  if (severe) {
    const min = b * (BOGIE_IMBALANCE_THRESHOLD + 0.005);
    const max = b * 0.12;
    delta = min + rnd() * (max - min);
    if (rnd() < 0.5) delta = -delta;
  } else {
    delta = (rnd() * 2 - 1) * b * 0.025;
  }

  const bogie1_t = +(half + delta / 2).toFixed(1);
  return { bogie1_t, bogie2_t: +(b - bogie1_t).toFixed(1) };
}
